import { render, staticRenderFns } from "./YLDDetail.vue?vue&type=template&id=0a46a9be&scoped=true"
var script = {}
import style0 from "./YLDDetail.vue?vue&type=style&index=0&id=0a46a9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46a9be",
  null
  
)

export default component.exports